// 字符串 转json
export const stringToJson = (value) => {
  let qrObj = {};
  try {
    qrObj = JSON.parse(value);
  } catch (err) {
    return qrObj;
  }
  return qrObj;
};

// json 转字符串
export const jsonToString = (obj) => {
  let objStr = '';
  try {
    objStr = JSON.stringify(obj);
  } catch (err) {
    return '';
  }
  return objStr;
};
